import { render, staticRenderFns } from "./PopTable.vue?vue&type=template&id=48bfdaf6&scoped=true&"
import script from "./PopTable.vue?vue&type=script&lang=js&"
export * from "./PopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bfdaf6",
  null
  
)

export default component.exports